module.exports = "/packs/images/homepage/activity/performing_arts_mobile~ddc10330dd871f2e3b9622feee2eec1a.jpg";